'use client';

import { useMemo } from 'react';
import { useHpApiListingsV3Handler_priceHistory } from '@zg-rentals/ts-hotpads-api-client-react-query';
import { getClient } from '@zg-rentals/ts-hotpads-api-client/client';
import { PRICE_HISTORY_QUERY_DETAILS, type PriceHistoryIdentity } from '@/src/lib/utils/priceHistoryIdentity';

export function usePriceHistory(identity?: PriceHistoryIdentity) {
  const enabled = Boolean(identity);
  const httpClient = useMemo(() => getClient()?.extend({ retry: 0, cache: 'no-store' }), []);
  const query = useHpApiListingsV3Handler_priceHistory(identity ?? { listingAlias: '', modelId: '' }, {
    enabled,
    httpClient,
    gcTime: 0,
    meta: { tags: ['priceHistory'], context: { api: 'hotpads-api', details: PRICE_HISTORY_QUERY_DETAILS } },
  });

  return {
    history: enabled && query.isSuccess && !query.data.error ? query.data.data : undefined,
    isLoading: enabled && query.isPending,
    error: enabled ? query.error : null,
  };
}
